import { Axios } from '../api';
import { REGISTERS_API_URL } from '../constants';
import { type AppDatabase } from '../db';
import type { Tax } from '../models';
import { toBooleanValueFields } from '../transform';
import {
    BOOLEAN_VALUE,
    TAX_TYPE,
    type MappedConfigurationResponse,
    type MappedTaxResponse,
} from '../types';

export class TaxService {
    constructor(private readonly db: AppDatabase) {
        this.db = db;
    }

    async fetchAndBulkUpsert() {
        const response = await Axios.get<MappedConfigurationResponse>(
            REGISTERS_API_URL.REGISTER.CONFIGURATION,
        );

        await this.bulkUpsert(response.data.taxConfiguration);
    }

    async bulkUpsert(taxes: MappedTaxResponse[]) {
        const output = taxes.map((item) => {
            return toBooleanValueFields(item, ['deleted']);
        });

        await this.db.taxes.bulkPut(output as unknown as Tax[]);
    }

    async getById(id: string) {
        return this.db.taxes.get(id);
    }

    async getTaxesByIds(taxIds: string[]) {
        return this.db.taxes
            .where('[id+deleted]')
            .anyOf(taxIds.map((id) => [id, BOOLEAN_VALUE.FALSE]))
            .toArray();
    }

    async getAll() {
        return this.db.taxes
            .where('deleted')
            .equals(BOOLEAN_VALUE.FALSE)
            .toArray();
    }

    async getAllGlobalTaxes() {
        return this.db.taxes
            .where('[taxType+deleted]')
            .equals([TAX_TYPE.GLOBAL, BOOLEAN_VALUE.FALSE])
            .toArray();
    }
}
